<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="5">
        <el-card shadow="never">
          <classify-select @change="handleSearch" ref="classify"></classify-select>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-input size="small" type="primary" style="width: 320px" v-model="keyWord" placeholder="输入 产品/方法/项目">
          <el-button slot="append" icon="el-icon-search" @click="initData" :loading="loading"></el-button>
        </el-input><span style="color: red;margin-left: 20px">具体项目价格请选完项目在下方机构列表 - 价格列 - 点击明细查看</span>
        <el-table border style="margin-top: 10px;"
                  height="450"
                  v-loading="loading"
                  :data="testProjectData">
          <el-table-column
            label="序号"
            align="center"
            type="index"
            width="80">
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="产品类别"
            width="120">
            <template slot-scope="scope">
              {{scope.row.typeName}}
            </template>
          </el-table-column>
          <el-table-column
            prop="itemName"
            label="产品/方法"
            width="140">
            <template slot-scope="scope">
              {{scope.row.itemName}}
              <el-tag v-if="scope.row.itemIsGb === '1'" size="mini" type="success" style="margin-left: 5px;">国标</el-tag>
              <el-tag v-if="scope.row.itemIsGb === '0'" size="mini" type="success" style="margin-left: 5px;">企标</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="itemName"
            label="细化分类"
            width="180">
            <template slot-scope="scope">
              <div v-if="scope.row.refines && scope.row.refines.length > 0">
                <el-tooltip class="item" effect="dark" :content="scope.row.selRefine.fullName" :disabled="!scope.row.selRefine.fullName" placement="top-start">
                  <el-input placeholder="请选择细化分类" readonly style="width: 160px;" v-model="scope.row.selRefine.fullName" class="input-with-select" size="mini">
                    <el-button slot="prepend" icon="el-icon-search" @click="openRefine(scope.row)" style="width: 25px"></el-button>
                  </el-input>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="mapList"
            label="检验项目">
            <template slot-scope="scope">
              <div v-for="(standard,index) in scope.row.standardList" :key="standard.itemId">
                <el-divider v-if="index>0"></el-divider>
                <standard-item :standard="standard" v-model="testProjectData[scope.$index].standardList[index].selectedItem" @change="selectItem"></standard-item>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog v-if="dialogPrice"
               title="细化分类"
               center
               :visible.sync="dialogPrice"
               :destroy-on-close = "true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               append-to-body
               width="400px">
      <refinetree :refines="refines" v-model="selRefine"></refinetree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogPrice = false">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAllProductStandardItems } from '@/api/test/entrust'
import ClassifySelect from './classify-select'
import StandardItem from './standard-item'
import refinetree from './refine-tree'
export default {
  name: 'select-product',
  components: { StandardItem, ClassifySelect, refinetree },
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      }
    },
    noCheckItemArray: {
      type: Array,
      default: function () {
        return []
      }
    },
    selRefines: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      dialogPrice: false,
      refines: null,
      selRefine: null,
      type: '',
      keyWord: '',
      loading: false,
      testProjectData: [],
      testProjectSelData: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  mounted () {
    //  this.initData()
  },
  methods: {
    openRefine (row) {
      this.refines = row.refines
      this.selRefine = row.selRefine
      this.dialogPrice = true
    },
    initData: function () {
      let para = {}
      para.type = this.type
      para.keyWord = this.keyWord
      para.noCheckItemArray = this.noCheckItemArray
      para.selRefines = this.selRefines
      para.entId = this.userInfo.companyId
      this.loading = true
      getAllProductStandardItems(para).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode === '0') {
          for (var i = 0; i < result.bizData.length; i++) {
            if (result.bizData[i].typeParentName !== null && result.bizData[i].typeParentName !== '') {
              result.bizData[i].typeName = result.bizData[i].typeParentName + ' - ' + result.bizData[i].typeName
            }
          }
          this.testProjectData = result.bizData
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('菜单树加载失败')
      })
    },
    handleSearch (cata) {
      this.type = cata
      this.initData()
    },
    selectItem () {
      // 筛选选中数据
      let arr = this.testProjectData.filter(project => {
        let tmp = project.standardList.filter(standrd => {
          return (standrd.selectedItem && standrd.selectedItem.length > 0)
        })
        return (tmp && tmp.length > 0)
      })
      this.testProjectSelData = []
      // 重新组装数据
      arr.forEach(item => {
        let newPro = {}
        newPro.itemId = item.itemId
        newPro.itemIsGb = item.itemIsGb
        newPro.itemName = item.itemName
        newPro.typeName = item.typeName
        // addby wjh 210115
        newPro.selRefine = item.selRefine
        newPro.refines = item.refines
        let arrStandard = []
        item.standardList.forEach(standrd => {
          let newStand = {}
          newStand.itemId = standrd.itemId
          newStand.itemIsGb = standrd.itemIsGb
          newStand.itemName = standrd.itemName
          newStand.standardList = standrd.selectedItem
          if (standrd.selectedItem && standrd.selectedItem.length > 0) {
            arrStandard.push(newStand)
          }
        })
        newPro.standardList = arrStandard
        this.testProjectSelData.push(newPro)
      })
    }
  },
  watch: {
    value (newValue) {
      this.testProjectSelData = newValue
    },
    testProjectSelData (newValue) {
      this.$emit('input', newValue)
    }
  }
}
</script>

<style scoped>

</style>
